// extracted by mini-css-extract-plugin
export var body = "FilterDialog-module--body--Aq9M+";
export var cancel = "FilterDialog-module--cancel--AiJ8-";
export var dialog = "FilterDialog-module--dialog--WXN6R";
export var footer = "FilterDialog-module--footer--GyEni";
export var header = "FilterDialog-module--header--o1k0g";
export var submit = "FilterDialog-module--submit--hVclf";